import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  className?: string;
}

const KlubHealhAndWellnessIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#044236",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 96 96"
      fill="none"
    >
      <path
        d="M48 32C52.4183 32 56 28.4183 56 24C56 19.5817 52.4183 16 48 16C43.5817 16 40 19.5817 40 24C40 28.4183 43.5817 32 48 32Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.8386 38.321C35.4454 37.0264 36.6316 36.2078 37.9266 36.0345L37.9258 36.0151H38.1011C38.3278 35.9951 38.5571 35.9948 38.7866 36.0151H56.9527C57.1822 35.9948 57.4115 35.9951 57.6382 36.0151C59.0004 36.1355 60.2667 36.9685 60.9007 38.321L68.0577 53.5897H71.0451C73.2518 53.5897 75.0406 55.4197 75.0406 57.6771C75.0406 59.9345 73.2518 61.7645 71.0451 61.7645H65.5426C64.0055 61.7645 62.6046 60.8624 61.94 59.4445L57.2644 49.4697L56.8665 63.7894C56.8242 65.3123 55.9205 66.6789 54.5358 67.314L49.6493 69.5555C48.5905 70.0411 47.3727 70.0411 46.3139 69.5555L41.4085 67.3054C40.0417 66.6784 39.142 65.3379 39.0797 63.8354L38.4831 49.4522L33.7993 59.4445C33.1347 60.8624 31.7338 61.7645 30.1967 61.7645H24.6942C22.4876 61.7645 20.6988 59.9345 20.6988 57.6771C20.6988 55.4197 22.4876 53.5897 24.6942 53.5897H27.6816L34.8386 38.321ZM45.7176 41.0214H45.6821C45.5925 41.0201 45.5023 41.0259 45.4134 41.038C44.8855 41.0976 44.404 41.3116 44.0133 41.6346C43.4543 42.0972 43.0827 42.7822 43.0332 43.5555C43.0294 43.6145 43.0275 43.6741 43.0275 43.7343C43.0275 43.7945 43.0294 43.8535 43.0332 43.9124V45.1132C43.0332 45.7116 43.3229 46.2729 43.8094 46.6164L47.2402 49.1684C47.4441 49.312 47.6811 49.3837 47.9187 49.3837C48.1491 49.3837 48.3802 49.312 48.5779 49.1685L51.9147 46.6168C52.3879 46.2734 52.6697 45.7122 52.6697 45.1138V43.9158C52.6734 43.8562 52.6758 43.796 52.6758 43.7352C52.6758 43.6743 52.674 43.6141 52.6697 43.5545C52.6208 42.7819 52.2594 42.0964 51.7164 41.6345C51.3364 41.3116 50.8675 41.0976 50.3541 41.038C50.2676 41.0259 50.1799 41.0201 50.0934 41.0214H50.0594C49.1741 41.0214 48.3919 41.4775 47.9187 42.1752C47.4321 41.4774 46.6273 41.0214 45.7176 41.0214Z"
        fill={color}
      />
      <path
        d="M27.6405 64.6963H27.6496C29.5213 64.8201 39.8416 69.9586 46.7057 73.3763C46.9161 73.481 47.1143 73.6246 47.309 73.7658C47.4972 73.9021 47.6821 74.0361 47.8718 74.1305C44.4599 73.3553 36.5663 74.8735 29.8966 79.9996H27.5446C23.3836 79.9996 20 76.5671 20 72.3461C20 68.1288 23.3726 64.6963 27.6405 64.6963Z"
        fill={color}
      />
      <path
        d="M37.5042 79.9996L47.8718 74.1305C55.1814 70.3108 66.0455 64.8563 68.4392 64.6963H68.4483C72.6666 64.6963 76 68.1288 76 72.3461C76 76.5671 72.6557 79.9996 68.543 79.9996H37.5042Z"
        fill={color}
      />
      <path
        d="M75.2969 15.2969H72.7031V12.7031C72.7031 12.3148 72.3883 12 72 12C71.6117 12 71.2969 12.3148 71.2969 12.7031V15.2969H68.7031C68.3148 15.2969 68 15.6117 68 16C68 16.3883 68.3148 16.7031 68.7031 16.7031H71.2969V19.2969C71.2969 19.6852 71.6117 20 72 20C72.3883 20 72.7031 19.6852 72.7031 19.2969V16.7031H75.2969C75.6852 16.7031 76 16.3883 76 16C76 15.6117 75.6852 15.2969 75.2969 15.2969Z"
        fill={color}
      />
      <path
        d="M23.2969 35.2969H20.7031V32.7031C20.7031 32.3148 20.3883 32 20 32C19.6117 32 19.2969 32.3148 19.2969 32.7031V35.2969H16.7031C16.3148 35.2969 16 35.6117 16 36C16 36.3883 16.3148 36.7031 16.7031 36.7031H19.2969V39.2969C19.2969 39.6852 19.6117 40 20 40C20.3883 40 20.7031 39.6852 20.7031 39.2969V36.7031H23.2969C23.6852 36.7031 24 36.3883 24 36C24 35.6117 23.6852 35.2969 23.2969 35.2969Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubHealhAndWellnessIcon;
